import * as actionTypes from './actionTypes';

export const setInterestEnhancementDetail = data => ({
  type: actionTypes.SAVE_INTEREST_ENHANCEMENT,
  data
})

export const setInterestEnhancementAccounts = acc => ({
  type: actionTypes.SAVE_INTEREST_ENHANCEMENT_ACCOUNTS,
  acc
})

export const setInterestEnhancementCountryList = countries =>  ({
  type: actionTypes.SAVE_INTEREST_ENHANCEMENT_COUNTRY_LIST,
  countries
})


export const setInterestEnhancementCurrency = currencies => ({
  type: actionTypes.SAVE_INTEREST_ENHANCEMENT_CURRENCY,
  currencies
})
export const setDeletedtTierIndex = deletedIndex => ({
  type: actionTypes.SET_DELETED_TIER_INDEX,
  deletedIndex
})

export const resetDeletedtTierIndex = () => ({
  type: actionTypes.RESET_DELETED_TIER_INDEX
})

export const setPremiumMarginValue = val => ({
  type: actionTypes.SET_PREMIUM_MARGIN_VALUE,
  val
})

export const deleteAccountFromDetailSetting = id => ({
  type: actionTypes.DELETE_FROM_DETAIL_SETTING,
  id
})

export const setIETabStatus = data => ({
  type: actionTypes.SET_IE_TAB_STATUS,
  data
})



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsInterestEnhancement/actions/actionCreator.js